<template>
    <CardRh :processando="processando" titulo="Impedimentos">
        <div class="impedimento-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaImpedimento" class="form-label">Pesquisar</label>
                        <input id="pesquisaImpedimento" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Cpf ou nome" />
                    </div>  
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataImpedimento" class="form-label">Data</label>
                        <input id="dataImpedimento" v-model="dataSearch" @change="refreshTable" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMinImpedimento" class="form-label">Data Minima</label>
                        <input id="dataMinImpedimento" v-model="dataMin" @change="refreshTable" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMaxImpedimento" class="form-label">Data Maxima</label>
                        <input id="dataMaxImpedimento" v-model="dataMax" @change="refreshTable" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-lg-3 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                    </div>
                </div>
            </section> 
            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Data</th>
                    <th>Inicio</th>
                    <th>Fim</th>
                    <th>Criado em</th>
                    <th>Ultima Atualizacao</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>



<script lang="ts">
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import ImpedimentoInstrutorService from "@/service/v1/sigap/ImpedimentoInstrutorService";

@Options({
    name: "ImpedimentoInstrutorIndex",
    components: { CardRh, KDataTable },
})
export default class ImpedimentoInstrutorIndex extends IndexModelTable {
    public service = new ImpedimentoInstrutorService();
    public dataSearch = "";
    public dataMin = "";
    public dataMax = "";
    public search = "";

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.dataSearch = "";
        this.dataMin = "";
        this.dataMax = "";
        this.refreshTable();
    }

    created() {
        this.config.order = [[2, "desc"],[3, "desc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    Data: this.dataSearch,
                    DataMin: this.dataMin,
                    DataMax: this.dataMax,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: "id", name: "id" },
            { data: "professor.nome", name: "professor" },
            { data: "data", name: "data" },
            { data: "inicio", name: "inicio" },
            { data: "fim", name: "fim" },
            { data: "createdAt", name: "createdAt" },
            { data: "updatedAt", name: "updatedAt" },
        ];
        this.config.columnDefs = [
            {
                targets: 2,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 3,
                render: function (row) {
                    return row ? row.substring(0, 5) : null;
                }
            },
            {
                targets: 4,
                render: function (row) {
                    return row ? row.substring(0, 5) : null;
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return SiteUtils.formatDataHora(row);
                }
            },
            {
                targets: 6,
                render: function (row) {
                    return SiteUtils.formatDataHora(row);
                }
            },
        ];
    }
}
</script>

<style scoped>
.impedimento-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

.card-header {
    min-height: 50px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
